import { cx } from '@/utils/strings'
import { TypePrice } from '@/types/ctf'
import { useLocale } from '@/utils/locale'
import { useMemo } from 'react'

type PriceProps = {
  className?: string
  price?: TypePrice<'WITHOUT_UNRESOLVABLE_LINKS'>
}

export default function Price({ className, price }: PriceProps) {
  const { currentLocale } = useLocale()

  const formattedPrice = useMemo(() => {
    if (!price) return null
    return new Intl.NumberFormat(currentLocale, {
      style: 'currency',
      currency: 'USD',
    }).format(price?.fields.value || 0)
  }, [currentLocale, price])

  if (!price) return null
  return <span className={cx(className)}>{formattedPrice}</span>
}
